export { SubSectionHeading } from './SubSectionHeading';
export type { SubSectionHeadingProps } from './SubSectionHeading';
